<template>
  <v-dialog width="620" v-model="dialog" persistent scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <v-toolbar-title>TẠO ĐƠN PHÚC KHẢO</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-6 pt-6 pb-0">
        <v-form v-bind="this.$attrs" ref="form">
          <AutoCompleteStudentExam
            :syncedValue.sync="student"
            item-text="name"
            clear-icon="mdi-close"
            label="Thí sinh"
            outlined
            deletable-chips
            hide-details
            :displaySubjectGroup="true"
            class="mb-6"
            :exam="exam"
          />
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn color="blue darken-4" outlined @click="close">Hủy </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-4" dark @click="submit" :disabled="!student">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AutoCompleteStudentExam from '@/components/basic/input/AutoCompleteStudentExam'

export default {
  props: {
    state: Boolean,
    exam: String
  },
  components: {
    AutoCompleteStudentExam
  },
  watch: {
    state(state) {
      this.dialog = state
      if (!state) this.loading = false
    }
  },
  computed: {
    ...mapGetters('auth', ['user'])
  },
  async mounted() {},
  data() {
    return {
      dialog: false,
      loading: false,
      student: null,
      room: '',
      subject: '',
      exams: [],
      subjects: [],
      rooms: [],
      filteredSubjects: []
    }
  },
  methods: {
    ...mapActions('gradeReview', ['createGradeReview']),
    ...mapActions('subjectExam', ['fetchSubjects']),
    ...mapActions('room', ['fetchRooms']),
    ...mapActions('exam', ['fetchExams']),
    close() {
      this.$emit('closeDialog')
      this.$refs.form.resetValidation()
    },
    async submit() {
      if (this.$refs.form.validate()) {
        this.$loading.active = true
        let data = {
          student: this.student.id,
          exam: this.exam
        }
        const createProd = await this.createGradeReview({ ...data })

        if (createProd) {
          this.$emit('refresh')
          this.resetForm()
          this.close()
        } else {
          this.$alert.error('Lỗi phân công')
        }
        this.$loading.active = false
      }
    },
    resetForm() {
      this.student = null
    }
  }
}
</script>

<style>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 2px !important;
}
</style>
